import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import Expander from '@starbucks-web/pattern-library/lib/components/expander';
import shouldDisplayError from '@starbucks-web/pattern-library/lib/components/form-container/should-display-error';
import Field from '@starbucks-web/pattern-library/lib/components/field';

import {
  customAmountMinSelector,
  customAmountMaxSelector,
} from 'gift/app/state/selectors';
import styles from './styles.cssm';
import messages from './messages';

const CustomAmountField = ({
  className,
  customAmount,
  customOptionValue,
  isActive,
  limitSigDigits,
}) => {
  const customAmountMin = useSelector(customAmountMinSelector);
  const customAmountMax = useSelector(customAmountMaxSelector);
  const { formatMessage, formatNumber } = useIntl();
  const inputRef = useRef(null);

  useEffect(() => {
    if (isActive) {
      // timeout required to wait for Expander to finish expanding
      setTimeout(() => {
        inputRef?.current?.focus();
      }, 100);
    }
  }, [isActive]);

  const customAmountId = customAmount?.input?.id ?? customOptionValue;

  const customAmountError = customAmount?.errorDetails?.existence
    ? formatMessage(messages.customAmountMissing)
    : formatMessage(messages.customAmountError, {
        minAmount: formatNumber(customAmountMin, limitSigDigits),
        maxAmount: formatNumber(customAmountMax, limitSigDigits),
      });

  return (
    <div className={styles.expanderWrapper}>
      <Expander isExpanded={isActive}>
        <div className={styles.fieldWrapper}>
          <Field
            id={customAmountId}
            ref={inputRef}
            type="number"
            {...customAmount.input}
            className={className}
            error={shouldDisplayError(customAmount)}
            errorMessage={customAmountError}
            max={customAmountMax}
            min={customAmountMin}
            pattern="[0-9]*"
            step="1"
          >
            <FormattedMessage
              defaultMessage="Enter custom dollar amount"
              description="Label for custom amount field"
              id="gift.customAmountField.label"
            />
          </Field>
        </div>
      </Expander>
    </div>
  );
};

CustomAmountField.propTypes = {
  className: PropTypes.string,
  customAmount: PropTypes.object,
  customAmountMax: PropTypes.number,
  customAmountMin: PropTypes.number,
  intl: PropTypes.object,
  isActive: PropTypes.bool,
  limitSigDigits: PropTypes.object,
};

CustomAmountField.defaultProps = {
  customAmount: {},
};

export default CustomAmountField;
